import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
import ToggleSwitch from "../../../shared/toggle-switch";
import getAppliedFilter from "../../../../utils/filters-v2/get-applied-filter";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import { yieldToMain } from "../../../../utils/helpers/yield-to-main";
import { AU_FILTER_EVENT, AU_FILTER_EVENTS_KEYS } from "../../../../tracking/au.mobile-filter-events";

const OnSale = ({appliedFilters, filter, onOptionSelection, saleLive}) => {
    const {options = [] } = filter || {};

    // eslint-disable-next-line max-params
    const handleChange = async (filterKey, optionKey, isSelected, displayText) => {
        await yieldToMain();
        onOptionSelection({ filterKey, optionKey, isSelected, displayText});
        if (isSelected) {
            trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_PROMOTION, {
                ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_PROMOTION],
                eventLabel: `${optionKey} On`});
        } else {
            trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_PROMOTION, {
                ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_PROMOTION],
                eventLabel: `${optionKey} Off`});
        }
    };

    const filteredOption = options.filter(item => item.key !== "Off sale"); //constant is not taking
    return (
        <React.Fragment>
            {(filteredOption || []).map((option) => {
                const isSelected = !!getAppliedFilter({
                    filterKey: filter.key,
                    optionKey: option.key
                }, appliedFilters, option.displayText);
                return (
                    <div styleName={"styles.onSaleWrapper"}>
                        <p styleName={"styles.onSale"}>{saleLive ? option.displayName : option.displayText}</p>
                        <p styleName={"styles.onSaleCount"}>({option.count})</p>
                        <ToggleSwitch onChangeCallback={handleChange.bind(null, filter.key, option.key, !isSelected, saleLive ? option.displayName : option.displayText)} checked={isSelected}/>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

OnSale.propTypes = {
    appliedFilters: PropTypes.array,
    filter: PropTypes.object,
    saleLive: PropTypes.object,
    onOptionSelection: PropTypes.func
};

export default OnSale;
// PROMOTION
